import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { NotebookPermissionManifest } from "models/interfaces/notebooks/notebook-permission-manifest";
import NotebookResourcePermissionRecord from "./notebook-resource-permission-record";
import NotebookPermissionRecipientRecord from "./notebook-permission-recipient-record";
import { NotebookResourcePermission } from "models/interfaces/notebooks/notebook-resource-permission";

const defaultValues =
    RecordUtils.defaultValuesFactory<NotebookPermissionManifest>({
        permission: undefined,
        recipient: undefined,
    });

export default class NotebookPermissionManifestRecord
    extends Record(defaultValues)
    implements NotebookPermissionManifest
{
    constructor(params?: Partial<NotebookPermissionManifest>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.permission != null) {
            params.permission = RecordUtils.ensureRecord(
                params.permission,
                NotebookResourcePermissionRecord
            );
        }

        if (params.recipient != null) {
            params.recipient = RecordUtils.ensureRecord(
                params.recipient,
                NotebookPermissionRecipientRecord
            );
        }

        super(params);
    }

    public with(
        values: Partial<NotebookPermissionManifest>
    ): NotebookPermissionManifestRecord {
        return new NotebookPermissionManifestRecord(
            Object.assign(this.toJS(), values)
        );
    }

    public withPermission(
        permission: Partial<NotebookResourcePermission>
    ): NotebookPermissionManifestRecord {
        const newPermission = this.permission.with(permission);
        return this.with({ permission: newPermission });
    }
}
